const getFlowsRequestState = state => state.automationTab.flows.requestState;
export default getFlowsRequestState;